module.exports = __webpack_public_path__ + "media/images/icons/self-storage-large-10x30-icon-437d8b81074979c12dd22aab3c0823e0.png";